(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["fulmor-product-order-v2"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const namespace = "__fulmorProductOrderV2";
    const selector = ".order-conversion-page.product-order-page[data-section-id]";
    const existing = window[namespace];

    if (existing) {
      existing.scan(document);
      return;
    }

    const instances = new WeakMap();

    function getSections(container) {
      const sections = [];
      if (container instanceof Element && container.matches(selector)) sections.push(container);
      container.querySelectorAll?.(selector).forEach((section) => sections.push(section));
      return sections;
    }

    function clampQuantity(input) {
      if (!input) return 1;
      const parsed = Number.parseInt(input.value, 10);
      const value = Number.isFinite(parsed) ? Math.min(9, Math.max(1, parsed)) : 1;
      input.value = String(value);
      return value;
    }

    function init(section) {
      if (instances.has(section)) return;

      const controller = new AbortController();
      const { signal } = controller;
      let animationFrame = 0;
      let menuFocusFrame = 0;
      const menuToggle = section.querySelector("[data-mobile-menu-toggle]");
      const mobileMenu = section.querySelector("[data-mobile-menu]");
      const menuClose = section.querySelector("[data-mobile-menu-close]");
      const menuLinks = mobileMenu?.querySelectorAll("[data-mobile-menu-link]") || [];

      function setMenuOpen(open, { restoreFocus = false } = {}) {
        if (!menuToggle || !mobileMenu) return;
        if (menuFocusFrame) {
          window.cancelAnimationFrame(menuFocusFrame);
          menuFocusFrame = 0;
        }

        menuToggle.setAttribute("aria-expanded", String(open));
        menuToggle.setAttribute("aria-label", open ? menuToggle.dataset.closeLabel : menuToggle.dataset.openLabel);
        mobileMenu.hidden = !open;
        mobileMenu.inert = !open;
        mobileMenu.toggleAttribute("inert", !open);
        section.classList.toggle("mobile-menu-open", open);

        if (open) {
          menuFocusFrame = window.requestAnimationFrame(() => {
            menuFocusFrame = 0;
            mobileMenu.querySelector("[data-mobile-menu-link]")?.focus();
          });
        } else if (restoreFocus) {
          menuToggle.focus();
        }
      }

      const destroy = () => {
        setMenuOpen(false);
        controller.abort();
        if (animationFrame) window.cancelAnimationFrame(animationFrame);
        if (menuFocusFrame) window.cancelAnimationFrame(menuFocusFrame);
        section.classList.remove("mobile-buy-visible");
      };
      instances.set(section, { destroy });

      setMenuOpen(false);
      menuToggle?.addEventListener("click", () => {
        setMenuOpen(menuToggle.getAttribute("aria-expanded") !== "true");
      }, { signal });
      menuClose?.addEventListener("click", () => setMenuOpen(false, { restoreFocus: true }), { signal });
      menuLinks.forEach((link) => link.addEventListener("click", () => setMenuOpen(false), { signal }));
      document.addEventListener("keydown", (event) => {
        if (event.key !== "Escape" || menuToggle?.getAttribute("aria-expanded") !== "true") return;
        event.preventDefault();
        setMenuOpen(false, { restoreFocus: true });
      }, { signal });
      window.addEventListener("resize", () => {
        if (!window.matchMedia("(max-width: 1050px)").matches) setMenuOpen(false);
      }, { signal });

      if (section.dataset.purchasable !== "true") return;

      const form = section.querySelector("form.fulmor-shopify-product-form");
      if (!form) return;

      const quantity = form.querySelector("[data-quantity]");
      const variantId = form.querySelector("[data-variant-id]");
      const variantSelect = form.querySelector("[data-variant-select]");
      const returnToCheckout = form.querySelector("[data-return-to-checkout]");
      const directCheckout = form.querySelector("[data-direct-checkout]");
      const cartSubmit = form.querySelector("[data-cart-submit]");
      const mobileBuy = section.querySelector("[data-mobile-buy]");
      const price = section.querySelector("[data-variant-price]");
      const comparePrice = section.querySelector("[data-variant-compare-price]");
      const comparePriceValue = section.querySelector("[data-variant-compare-price-value]");
      const availability = section.querySelector("[data-variant-availability]");

      function updateVariant() {
        const option = variantSelect?.selectedOptions[0];
        if (!option) return;

        const isAvailable = option.dataset.available === "true";
        const compareAt = option.dataset.compareAtPrice || "";

        if (variantId) variantId.value = option.value;
        if (price) price.textContent = option.dataset.price || "";
        if (comparePriceValue) comparePriceValue.textContent = compareAt;
        if (comparePrice) comparePrice.hidden = !compareAt;
        if (availability) {
          availability.textContent = isAvailable ? section.dataset.availableLabel : section.dataset.soldOutLabel;
        }

        [directCheckout, cartSubmit, mobileBuy].forEach((button) => {
          if (button) button.disabled = !isAvailable;
        });
        if (directCheckout) {
          directCheckout.textContent = isAvailable ? section.dataset.orderLabel : section.dataset.soldOutLabel;
        }
        if (cartSubmit) {
          cartSubmit.textContent = isAvailable ? section.dataset.cartLabel : section.dataset.soldOutLabel;
        }
        if (mobileBuy) {
          mobileBuy.textContent = isAvailable ? section.dataset.orderLabel : section.dataset.soldOutLabel;
        }
      }

      variantSelect?.addEventListener("change", updateVariant, { signal });
      updateVariant();

      form.querySelectorAll("[data-step]").forEach((button) => {
        button.addEventListener("click", () => {
          const current = clampQuantity(quantity);
          const step = Number.parseInt(button.dataset.step, 10) || 0;
          if (quantity) quantity.value = String(Math.min(9, Math.max(1, current + step)));
        }, { signal });
      });

      quantity?.addEventListener("change", () => clampQuantity(quantity), { signal });
      quantity?.addEventListener("blur", () => clampQuantity(quantity), { signal });

      form.addEventListener("submit", (event) => {
        clampQuantity(quantity);
        const option = variantSelect?.selectedOptions[0];
        if (option && option.dataset.available !== "true") {
          event.preventDefault();
          return;
        }
        if (returnToCheckout) {
          returnToCheckout.disabled = !event.submitter?.matches("[data-direct-checkout]");
        }
      }, { signal });

      mobileBuy?.addEventListener("click", () => {
        clampQuantity(quantity);
        if (directCheckout && !directCheckout.disabled) form.requestSubmit(directCheckout);
      }, { signal });

      const cover = section.querySelector(".checkout-hero");
      const updateMobileBuyBar = () => {
        animationFrame = 0;
        const isMobile = window.matchMedia("(max-width: 760px)").matches;
        const shouldShow = Boolean(cover && isMobile && cover.getBoundingClientRect().bottom < 0);
        section.classList.toggle("mobile-buy-visible", shouldShow);
      };
      const queueMobileBuyBarUpdate = () => {
        if (animationFrame) return;
        animationFrame = window.requestAnimationFrame(updateMobileBuyBar);
      };

      window.addEventListener("scroll", queueMobileBuyBarUpdate, { passive: true, signal });
      window.addEventListener("resize", queueMobileBuyBarUpdate, { signal });
      updateMobileBuyBar();
    }

    function scan(container) {
      getSections(container).forEach(init);
    }

    function destroyWithin(container) {
      getSections(container).forEach((section) => {
        instances.get(section)?.destroy();
        instances.delete(section);
      });
    }

    document.addEventListener("shopify:section:load", (event) => scan(event.target));
    document.addEventListener("shopify:section:unload", (event) => destroyWithin(event.target));

    window[namespace] = { scan, destroyWithin };
    if (document.readyState === "loading") {
      document.addEventListener("DOMContentLoaded", () => scan(document), { once: true });
    } else {
      scan(document);
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
